import tw from "twin.macro"

export const Column = tw.div`
    px-4
    md:px-0
    flex-1
    flex
    flex-col
`
